<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
		<b-card>
			<b-row>
				<b-col cols="12">
					<app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
				</b-col>
			</b-row>
			<b-row v-if="isUploadSuccess">
				<b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Role Management" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="roleManagementPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="roleManagements" :fields="fieldsRoleManagement" :busy="isDataLoading" :sort-by.sync="sortByRoleManagement" :sort-desc.sync="sortDescRoleManagement" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowRoleManagementFilter = !isShowRoleManagementFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowRoleManagementFilter">
										<b-th></b-th>
										<b-th stacked-heading="Name">
											<b-form-input id="input-name-table" v-model="filterRoleManagement.name" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Description">
											<b-form-input id="input-description-table" v-model="filterRoleManagement.description" size="sm"></b-form-input>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( roleManagementPageSize * (currentRoleManagementPage - 1))) }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentRoleManagementPage"
									:total-rows="totalRoleManagementRow"
									:per-page="roleManagementPageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
							<b-tab title="Role Management Detail" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="roleManagementDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="roleManagementDetails" :fields="fieldsRoleManagementDetail" :busy="isDataLoading" :sort-by.sync="sortByRoleManagementDetail" :sort-desc.sync="sortDescRoleManagementDetail" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowRoleManagementDetailFilter = !isShowRoleManagementDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowRoleManagementDetailFilter">
										<b-th></b-th>
										<b-th>
										</b-th>
										<b-th stacked-heading="Function Info">
											<v-select append-to-body label="name" :options="functionInfos" :value="filterRoleManagementDetail.functionInfoId"  :reduce="item => item.id" v-model="filterRoleManagementDetail.functionInfoId" @search="getFunctionInfos" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Allow Create">
											<b-form-checkbox id="input-allow-create-table" @change="getRoleManagementDetails" class="float-right" v-model="filterRoleManagementDetail.allowCreate"></b-form-checkbox>
										</b-th>
										<b-th stacked-heading="Allow Read">
											<b-form-checkbox id="input-allow-read-table" @change="getRoleManagementDetails" class="float-right" v-model="filterRoleManagementDetail.allowRead"></b-form-checkbox>
										</b-th>
										<b-th stacked-heading="Allow Update">
											<b-form-checkbox id="input-allow-update-table" @change="getRoleManagementDetails" class="float-right" v-model="filterRoleManagementDetail.allowUpdate"></b-form-checkbox>
										</b-th>
										<b-th stacked-heading="Allow Delete">
											<b-form-checkbox id="input-allow-delete-table" @change="getRoleManagementDetails" class="float-right" v-model="filterRoleManagementDetail.allowDelete"></b-form-checkbox>
										</b-th>
										<b-th stacked-heading="Show In Menu">
											<b-form-checkbox id="input-show-in-menu-table" @change="getRoleManagementDetails" class="float-right" v-model="filterRoleManagementDetail.showInMenu"></b-form-checkbox>
										</b-th>
										<b-th stacked-heading="Allow Download">
											<b-form-checkbox id="input-allow-download-table" @change="getRoleManagementDetails" class="float-right" v-model="filterRoleManagementDetail.allowDownload"></b-form-checkbox>
										</b-th>
										<b-th stacked-heading="Allow Print">
											<b-form-checkbox id="input-allow-print-table" @change="getRoleManagementDetails" class="float-right" v-model="filterRoleManagementDetail.allowPrint"></b-form-checkbox>
										</b-th>
										<b-th stacked-heading="Allow Upload">
											<b-form-checkbox id="input-allow-upload-table" @change="getRoleManagementDetails" class="float-right" v-model="filterRoleManagementDetail.allowUpload"></b-form-checkbox>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( roleManagementDetailPageSize * (currentRoleManagementDetailPage - 1))) }}
									</template>
									<template v-slot:cell(roleManagement)="row">
										{{ row.item.roleManagement != null ? row.item.roleManagement.name : "" }}
									</template>
									<template v-slot:cell(functionInfo)="row">
										{{ row.item.functionInfo != null ? row.item.functionInfo.name : "" }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentRoleManagementDetailPage"
									:total-rows="totalRoleManagementDetailRow"
									:per-page="roleManagementDetailPageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
			</b-row>
		</b-card>
		<template #modal-footer="{ ok, cancel }">
			<b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
				Download Error Message
			</b-button>
			<b-button size="sm" variant="success" class="float-right" @click="ok()">
				{{ okTitle }}
			</b-button>
			<b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
				Cancel
			</b-button>
		</template>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<style lang="scss" scoped>
.card {
	border: 1px solid rgba(0, 0, 0, 0.125) !important;
}
::v-deep.th-message {
	color: red;
}
::v-deep.modal-footer {
	display: block;
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate"; 
import { required, minLength } from "vuelidate/lib/validators"; 
import { saveAs } from 'file-saver';

import RoleManagement from '@/models/RoleManagement/RoleManagement';
import RoleManagementList from '@/models/RoleManagement/RoleManagementList';
import RoleManagementFilter from '@/filters/RoleManagement/RoleManagementFilter';

import RoleManagementDetail from '@/models/RoleManagement/RoleManagementDetail';
import RoleManagementDetailFilter from '@/filters/RoleManagement/RoleManagementDetailFilter';
import FunctionInfo from '@/models/Core/FunctionInfo';
import FunctionInfoFilter from '@/filters/Core/FunctionInfoFilter';
import AppInputFileupload from '@/components/AppInputFileupload';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,AppInputDatetimepicker,AppInputDatetimepickerRange,},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fieldsRoleManagement: [
				{"no" : { "class" : "th-number"}}, 
				{"name": { "class" : "th-name", "label" : "Name"}, key: 'name', sortable: true}, 
				{"description": { "class" : "th-description", "label" : "Description"}, key: 'description', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsRoleManagementDetail: [
				{"no" : { "class" : "th-number"}}, 
				{"roleManagement": { "class" : "th-role-management", "label" : "RoleManagement"}, key: 'roleManagement', sortable: true}, 
				{"functionInfo": { "class" : "th-function-info", "label" : "Function Info"}, key: 'functionInfo', sortable: true}, 
				{"allowCreate": { "class" : "th-allow-create", "label" : "Allow Create"}, key: 'allowCreate', sortable: true}, 
				{"allowRead": { "class" : "th-allow-read", "label" : "Allow Read"}, key: 'allowRead', sortable: true}, 
				{"allowUpdate": { "class" : "th-allow-update", "label" : "Allow Update"}, key: 'allowUpdate', sortable: true}, 
				{"allowDelete": { "class" : "th-allow-delete", "label" : "Allow Delete"}, key: 'allowDelete', sortable: true}, 
				{"showInMenu": { "class" : "th-show-in-menu", "label" : "Show In Menu"}, key: 'showInMenu', sortable: true}, 
				{"allowDownload": { "class" : "th-allow-download", "label" : "Allow Download"}, key: 'allowDownload', sortable: true}, 
				{"allowPrint": { "class" : "th-allow-print", "label" : "Allow Print"}, key: 'allowPrint', sortable: true}, 
				{"allowUpload": { "class" : "th-allow-upload", "label" : "Allow Upload"}, key: 'allowUpload', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isDataLoading: false,
			isBusy : false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			roleManagements : [],
			roleManagementId : '',
			totalRoleManagementRow : 0,
			isShowRoleManagementFilter: false,
			filterRoleManagement : null,
			currentRoleManagementPage : 1,
			roleManagementPageSize: 10,
			sortByRoleManagement: '',
			sortDescRoleManagement: '',
			filterRoleManagementDetail : null,
			currentRoleManagementDetailPage : 1,
			roleManagementDetailPageSize: 10,
			sortByRoleManagementDetail: '',
			sortDescRoleManagementDetail: '',
			sortingByRoleManagementDetail: [],
			roleManagementDetails : [],
			roleManagementDetailId : '',
			totalRoleManagementDetailRow : 0,
			isShowRoleManagementDetailFilter: false,
			roleManagements: [],
			functionInfos: [],
			processId: "",
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'rolemanagement/confirmUpload',
					[],
					).then(async function(response){
						if (response != null) {
						if (response.data != null) {
							_this.resetModal();
							_this.datas = Array();
							_this.fileupload = null;
							_this.isUploadSuccess = false;
						}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
				let data = new FormData();
				data.append('file', this.fileupload);
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'rolemanagement/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.isBusy = false;
						_this.isUploadSuccess = true;
						_this.getRoleManagements();
						_this.getRoleManagementDetails();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getRoleManagements : async function() {
			let filter = {};
			Object.assign(filter, this.filterRoleManagement);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingByRoleManagement = Array();
			if (this.sortByRoleManagement != null) {
				this.sortingByRoleManagement[this.sortByRoleManagement] = this.sortDescRoleManagement;
			}
			let currentPage = (this.currentRoleManagementPage - 1);
			RoleManagement.getList(this, filter, this.sortingByRoleManagement, currentPage , this.roleManagementPageSize).then(result => {
				this.roleManagements = result.data;
				this.totalRoleManagementRow = result.dataCount;
			}).catch(error => {});
		},
		getRoleManagementDetails : async function() {
			let filter = {};
			Object.assign(filter, this.filterRoleManagementDetail);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingByRoleManagementDetail = Array();
			if (this.sortByRoleManagementDetail != null) {
				this.sortingByRoleManagementDetail[this.sortByRoleManagementDetail] = this.sortDescRoleManagementDetail;
			}
			let currentPage = (this.currentRoleManagementDetailPage - 1);
			RoleManagementDetail.getList(this, filter, this.sortingByRoleManagementDetail, currentPage , this.roleManagementDetailPageSize).then(result => {
				this.roleManagementDetails = result.data;
				this.totalRoleManagementDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getFunctionInfos : async function(input) {
			let filter = new FunctionInfoFilter();
			if (input != undefined) {
				filter.name = input;
			}
			FunctionInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.functionInfos = result.data
				}
			})
			.catch(error => {});
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowRoleManagementDetailFilter = true;
			}
		},
		downloadLog() {
			let _this = this;
			this.$http.post(process.env.VUE_APP_API_URL + 'rolemanagement/downloadlog', [],
			{ headers: { 'Content-Type': 'application/json' }}
			).then(async function(response){
				await saveAs(process.env.VUE_APP_API_URL + 'rolemanagement/downloadlog', "RoleManagement.xslx");
				_this.isBusy = false;
			})
			.catch(error => {
				_this.$store.dispatch('addErrorMessageGlobal', error);
				_this.isBusy = false;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		sortByRoleManagement : {
			handler: function() {
				this.getRoleManagements();
			}
		},
		sortDescRoleManagement: {
			handler: function() {
				this.getRoleManagements();
			}
		},
		currentRoleManagementPage: {
			handler: function() {
				this.getRoleManagements();
			}
		},
		roleManagementPageSize : {
			handler: function() {
				this.getRoleManagements();
			}
		},
		filterRoleManagement: {
			handler: function() {
				this.getRoleManagements();
			},
			deep: true,
		},
		sortByRoleManagementDetail : {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		sortDescRoleManagementDetail: {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		currentRoleManagementDetailPage: {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		roleManagementDetailPageSize : {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		filterRoleManagementDetail: {
			handler: function() {
				this.getRoleManagementDetails();
			},
			deep: true,
		},
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Proses";
				}
				return "Simpan";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterRoleManagement = new RoleManagementFilter();
					this.filterRoleManagementDetail = new RoleManagementDetailFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
